import type { PricingCardProps } from '@kkf/design'

const DESCR =
  'We care about their success. For us real We care about their success. For us real relationship.'

const FEATURES = [
  'Providing solutions',
  'Service that matters',
  'Giving our best',
  '24/7 Skilled Support',
  'We serve differently',
]

/** Pricing plans — the three share copy and differ only in name and price. */
export const PRICING_PLANS: PricingCardProps[] = [
  { name: 'Basic', price: '$19', duration: 'Month', descr: DESCR, features: FEATURES, ctaLabel: 'Choose a Plan', ctaHref: '#' },
  { name: 'Standard', price: '$59', duration: 'Month', descr: DESCR, features: FEATURES, ctaLabel: 'Choose a Plan', ctaHref: '#' },
  { name: 'Premium', price: '$110', duration: 'Month', descr: DESCR, features: FEATURES, ctaLabel: 'Choose a Plan', ctaHref: '#' },
]
